import React from "react";
import { Container, Stack, Typography, Divider, Box, Chip, Paper } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faBolt,
    faChild,
    faHandshake,
    faDumbbell,
    faLeaf,
    faSun,
    faCheckCircle,
    faTools,
} from "@fortawesome/free-solid-svg-icons";
// @ts-ignore
import oldLogo from "@logo/vld-2026.png";
import SectionTitle from "@others/title-section.layout";

const ARTICLE20250909: React.FC = () => {
    return (
        <Container maxWidth="lg" sx={{ mb: 6 }}>
            <SectionTitle title="ESPACE INFORMATIONS DES HABITANTS" />
            <Stack spacing={3}>
                <Box textAlign="center">
                    <img
                        src={oldLogo}
                        alt="Association Vivre la démocratie à BLR"
                        style={{ width: 300, marginBottom: 10, marginTop: 10 }}
                    />
                    <Typography
                        variant="h5"
                        color="primary"
                        fontWeight={700}
                        gutterBottom
                        sx={{ pt: 1, pb: 1 }}
                    >
                        Donnons aux associations sportives bacottes l’espace et l’énergie qu’elles méritent&nbsp;!
                    </Typography>
                </Box>
                <Divider />

                <Stack direction="row" spacing={1} alignItems="center" justifyContent="center" mb={1}>
                    <FontAwesomeIcon icon={faHandshake} color="#1976d2" />
                    <Typography variant="subtitle1" fontWeight={700} color="primary">
                        Dimanche 7 septembre, au Forum des Associations
                    </Typography>
                </Stack>
                <Typography align="center" color="text.secondary">
                    Vous avez été nombreux à venir échanger avec nous. Ce moment chaleureux confirme une évidence&nbsp;: les associations sont le cœur battant de notre village&nbsp;! Vos idées, vos attentes, mais aussi vos difficultés, nous les avons entendues.
                </Typography>

                <Box sx={{ bgcolor: "#f9fbe7", borderRadius: 2, p: 2 }}>
                    <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                        <FontAwesomeIcon icon={faChild} color="#ffa000" />
                        <Typography fontWeight={700} color="text.primary">
                            Les bénévoles et la jeunesse en première ligne…
                        </Typography>
                    </Stack>
                    <Typography color="text.secondary">
                        Ainsi, c’est tellement frustrant pour vous, bénévoles, de devoir refuser des inscriptions de jeunes Bacots à des activités sportives faute d’équipements suffisants,
                    </Typography>
                </Box>

                <Stack direction="row" spacing={1} alignItems="center" mt={2} mb={1}>
                    <FontAwesomeIcon icon={faBolt} color="#009688" />
                    <Typography fontWeight={700}>Votre énergie mérite des réponses concrètes&nbsp;!</Typography>
                </Stack>

                <Typography>
                    Pour vous donner les moyens d’agir, deux projets solides sont déjà à l’étude&nbsp;:
                </Typography>
                <Stack component="ul" spacing={1} sx={{ pl: 3 }}>
                    <Stack component="li" direction="row" alignItems="center" spacing={1}>
                        <FontAwesomeIcon icon={faDumbbell} color="#43a047" />
                        <Typography component="span">
                            <b>Un gymnase temporaire, démontable et respectueux de l’environnement</b>, pour que les clubs puissent continuer leurs activités sans attendre le futur équipement,
                        </Typography>
                    </Stack>
                    <Stack component="li" direction="row" alignItems="center" spacing={1}>
                        <FontAwesomeIcon icon={faSun} color="#fbc02d" />
                        <Typography component="span">
                            <b>Une structure sportive solaire</b> (ombrière équipée de panneaux photovoltaïques), pour allier sport et écologie,
                        </Typography>
                    </Stack>
                </Stack>

                <Paper elevation={0} sx={{ mt: 2, p: 2, maxWidth: 450, mx: "auto", background: "#e3f2fd" }}>
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <FontAwesomeIcon icon={faTools} color="#1976d2" />
                        <Typography fontWeight={600}>
                            Les premiers devis sont lancés. Des solutions prennent forme.
                        </Typography>
                    </Stack>
                </Paper>

                <Stack direction="row" spacing={1} alignItems="center" mt={2} mb={2} justifyContent="center">
                    <FontAwesomeIcon icon={faCheckCircle} color="#43a047" />
                    <Typography fontWeight={600} color="primary">
                        Nous sommes avec vous pour faire avancer ces dossiers.
                    </Typography>
                </Stack>
                <Divider />

                <Box textAlign="center" mt={2} mb={2}>
                    <Chip
                        icon={<FontAwesomeIcon icon={faLeaf} />}
                        label="Ensemble, donnons du souffle, de l’espace et un vrai avenir à la vie associative et au développement des activités sportives à Bois-le-Roi !"
                        sx={{
                            fontWeight: 700,
                            fontSize: "1rem",
                            background: "#c8e6c9",
                            color: "#24522c",
                            py: 2,
                            px: 1,
                            borderRadius: "10px"
                        }}
                    />
                </Box>
                <Typography align="center" variant="subtitle2" sx={{ fontStyle: "italic" }}>
                    Votre équipe VLD2026
                </Typography>
            </Stack>
        </Container>
    );
};

export default ARTICLE20250909;